import constants from '../constants/actions';
import APP from 'app';

const { Utils } = APP,
    { getJwtToken } = Utils,
    initialState = {
        footerLinks: [],
        sbt: ''
    };

export default function footerReducer(state = initialState, action) {
    try {
        const { type = '', payload = [] } = action;
        const { data = [], meta = {} } = payload;
        switch (action.type) {
            case constants.FOOTER.GET_FOOTER: {
                const sbt = getJwtToken('SBT');
                return {
                    ...state,
                    type,
                    footerLinks: data,
                    sbt,
                    metaData: meta
                };
            }

            default:
                return state;
        }

    } catch (error) {
        console.log('Menubar Try catch Error ', error);
        return state;
    }
}
